import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useApi, img } from "@/lib/api";
import { Lightbox } from "@/components/site/Lightbox";
import { useLang } from "@/lib/i18n";

export const GalleryStrip = ({ className = "", testId = "gallery-strip", count = 6 }) => {
  const { t, L, to } = useLang();
  const { data } = useApi("/gallery", []);
  const [idx, setIdx] = useState(null);
  if (!data.length) return null;
  const photos = data.map((g) => ({ src: g.image, alt: L(g, "caption") || "Escamequita, Nicaragua" }));
  return (
    <section className={className} data-testid={testId}>
      <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
        <h2 className="text-3xl font-black tracking-tight text-forest sm:text-4xl">{t("gstrip.title")}</h2>
        <Link to={to("/gallery")} className="inline-flex items-center gap-1.5 text-sm font-bold text-forest hover:underline" data-testid={`${testId}-all`}>{t("gstrip.cta")} <ArrowRight className="h-4 w-4" /></Link>
      </div>
      <div className="grid grid-cols-2 gap-3 sm:gap-4 md:grid-cols-3">
        {data.slice(0, count).map((g, i) => (
          <button key={g.id} type="button" onClick={() => setIdx(i)} className="img-zoom relative aspect-[4/3] overflow-hidden rounded-2xl" data-testid={`${testId}-item-${i}`}>
            <img src={img(g.image)} alt={L(g, "caption") || "Escamequita, Nicaragua"} loading="lazy" className="h-full w-full object-cover" />
          </button>
        ))}
      </div>
      {idx !== null && <Lightbox images={photos} index={idx} onChange={setIdx} onClose={() => setIdx(null)} />}
    </section>
  );
};
